var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-container',{attrs:{"fluid":"","fill-height":"","ma-0":"","pa-0":"","id":"page-container"}},[_c('v-layout',[_c('sidebar'),_c('v-flex',{attrs:{"text-xs-center":"","id":"page-content"}},[_c('router-view')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }